import Vue from 'vue'
import Router from 'vue-router'
import main from '@/views/main.vue';

import home from '@/views/zb/home.vue';
import tgfc from '@/views/zb/tgfc.vue';
import zjhz from '@/views/zb/zjhz.vue';
import video from '@/views/zb/video.vue';
import hisvideo from '@/views/zb/hisvideo.vue';

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: main,
      children:[
        {
          path: '/',
          redirect:'/home'
        },
        {
            path: '/home',
            name: 'home',
            component: home,
            meta: {
              tabname:'home'
            }
        },
        {
            path: '/tgfc',
            name: 'tgfc',
            component: tgfc,
            meta: {
              tabname:'tgfc',

            }
        },
        {
            path: '/zjhz',
            name: 'zjhz',
            component: zjhz,
            meta: {
              tabname:'zjhz',

            }
        },
        {
          path: '/video',
          name: 'video',
          component: video,
          meta: {
            tabname:'video',
          },
        },
        {
          path: '/hisvideo',
          name: 'hisvideo',
          component: hisvideo,
          meta: {
            tabname:'hisvideo',
          }
        }
      ]
    },
    // {
    // 	path:'/login',
    // 	name :'login',
    // 	component:login
    // },
  ]
})
Vue.use(Router)



// WEBPACK FOOTER //
// ./src/router/index.js